import { TruckTypeModel } from '@/types';

export interface TruckTypeState {
  isLoading: boolean;
  data: TruckTypeModel[];
}

export const truckTypeStateActions = [
  'truck_type_load_start',
  'truck_type_load_end',
  'truck_type_update_data',
] as const;

export type TruckTypeStateAction = (typeof truckTypeStateActions)[number];
